import i18n from '@/main';

export const regras = {
    idFornecedor: [
        {
            required: true,
            message: i18n.t('configuracaoParametros.erro.campoEstadoErro'),
            trigger: 'change'
        }
    ]
};
export const regrasExececoes = {
    idEstado: [
        {
            message: i18n.t('configuracaoParametros.erro.campoEstadoErro'),
            trigger: 'change'
        }
    ],
    idMunicipio: [
        {
            message: i18n.t('configuracaoParametros.erro.campoMunicipioErro'),
            trigger: 'change'
        }
    ]
};

export default regras;
